import { render } from "./subpartA01.vue?vue&type=template&id=05158ce0&scoped=true"
import script from "./subpartA01.vue?vue&type=script&lang=js"
export * from "./subpartA01.vue?vue&type=script&lang=js"

import "./subpartA01.vue?vue&type=style&index=0&id=05158ce0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05158ce0"]])

export default __exports__